module.exports = __webpack_public_path__ + "static/media/makes_selection_tick.ac2a9b15.svg";